import { ToolDisplay } from './ToolDisplay.tsx';

/**
 * Default render component for tools that declare a `display` spec but no
 * custom `render`. Renders an empty {@link ToolDisplay}, which then reads
 * the registered tool's `display` spec and synthesises its slots
 * automatically. Tools needing full JSX control should provide their own
 * `render` instead.
 */
export function DefaultToolDisplayRender() {
  return <ToolDisplay />;
}
